module.exports = __webpack_public_path__ + "images/events-placeholder-2.jpg";